import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import {
  Box, Paper, Typography, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Button, TextField,
  MenuItem, Grid, Chip, IconButton, Dialog, DialogContent,
  DialogTitle, CircularProgress, Tabs, Tab,DialogActions,Alert
} from '@mui/material';
import { Add, Search, Visibility, Close,FileDownload,PictureAsPdf,Edit } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { labourAPI, categoryAPI, siteAPI } from '../services/api';

const LabourList = () => {
  const navigate = useNavigate();
  const [labour, setLabour] = useState([]);
  const [categories, setCategories] = useState([]);
  const [sites, setSites] = useState([]);
  const [filters, setFilters] = useState({ search: '', category_id: '', site_id: '' });
  const [selectedLabour, setSelectedLabour] = useState(null);
  const [openDetails, setOpenDetails] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
const [editForm, setEditForm] = useState({
  name: '', mobile: '', aadhar_no: '', address: '',
  category_id: '', site_id: '', emergency_contact: ''
});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
const [error, setError] = useState('');
  const [tab, setTab] = useState(0);
  const [inactiveLabour, setInactiveLabour] = useState([]);
  const [totalActive, setTotalActive] = useState(0);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (tab === 1) {
      loadInactiveLabour();
    }
  }, [tab]);

  const loadData = async () => {
    setLoading(true);
    try {
      const [labRes, catRes, siteRes, countRes] = await Promise.all([
        labourAPI.getAll(),
        categoryAPI.getAll(),
        siteAPI.getAll(),
        labourAPI.getActiveCount()
      ]);
      setLabour(labRes.data.data);
      setCategories(catRes.data.data);
      setSites(siteRes.data.data);
      setTotalActive(countRes.data.count);
    } catch (err) {
      console.error('Load error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
  setLoading(true);
  try {
    const params = {};
    // Sirf non-empty values bhejo
    if (filters.search.trim()) {
      params.search = filters.search.trim();
    }
    if (filters.category_id) {
      params.category_id = filters.category_id;
    }
    if (filters.site_id) {
      params.site_id = filters.site_id;
    }

    const res = await labourAPI.getAll(params);
    setLabour(res.data.data);
  } catch (err) {
    console.error('Search error:', err);
  } finally {
    setLoading(false);
  }
};

  const loadInactiveLabour = async () => {
    setLoading(true);
    try {
      const res = await labourAPI.getInactive();
      setInactiveLabour(res.data.data);
    } catch (err) {
      console.error('Inactive load error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = (lab) => {
    setSelectedLabour(lab);
    setOpenDetails(true);
  };

  const handleEditOpen = (lab) => {
  setSelectedLabour(lab);
  setEditForm({
    name: lab.name || '',
    mobile: lab.mobile || '',
    aadhar_no: lab.aadhar_no || '',
    address: lab.address || '',
    category_id: lab.category_id || '',
    site_id: lab.site_id || '',
    emergency_contact: lab.emergency_contact || ''
  });
  setOpenEdit(true);
};

const handleEditSave = async () => {
  try {
    await labourAPI.update(selectedLabour.id, editForm);
    setSuccess('Labour updated!');
    setOpenEdit(false);
    loadData();
  } catch (err) {
    setError(err.response?.data?.error || 'Update failed');
  }
};

  const handleToggleStatus = async (id, status) => {
  if (!window.confirm(status ? 'Labour ko active kare?' : 'Labour ko left mark kare?')) return;
  setLoading(true);
  try {
    await labourAPI.toggleStatus(id, status);
    loadData(); // active list refresh
  } catch (err) {
    console.error('Status update error:', err);
  } finally {
    setLoading(false);
  }
};

const handleExportExcel = () => {
  if (labour.length === 0) {
    alert('No data to export');
    return;
  }

  const exportData = labour.map((lab, idx) => ({
    'S.No': idx + 1,
    'Code': lab.labour_code,
    'Name': lab.name,
    'Mobile': lab.mobile || '-',
    'Category': lab.category_name,
    'Site': lab.site_name,
    'Our Rate': lab.our_rate_8hr || 0,
    'Advance': lab.total_advance_taken || 0,
    'Dues': lab.balance_due || 0,
  }));

  const ws = XLSX.utils.json_to_sheet(exportData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Labour');

  const filename = `Labour_List_${new Date().toISOString().split('T')[0]}.xlsx`;
  XLSX.writeFile(wb, filename);
};

const handleExportPDF = () => {
  if (labour.length === 0) {
    alert('No data to export');
    return;
  }

  const doc = new jsPDF();

  // Header
  doc.setFontSize(16);
  doc.setTextColor(26, 35, 126);
  doc.text('LabourBhai - Labour List', 14, 15);

  doc.setFontSize(10);
  doc.setTextColor(80);
  doc.text(`Total Active Labour: ${totalActive}`, 14, 22);
  doc.text(`Generated: ${new Date().toLocaleString('hi-IN')}`, 14, 27);

  // Table
  const tableData = labour.map((lab, idx) => [
    idx + 1,
    lab.labour_code,
    lab.name,
    lab.mobile || '-',
    lab.category_name,
    lab.site_name,
    `Rs.${lab.our_rate_8hr || 0}`,
    `Rs.${Number(lab.total_advance_taken || 0).toLocaleString()}`,
    `Rs.${Number(lab.balance_due || 0).toLocaleString()}`,
  ]);

  autoTable(doc, {
  startY: 32,
  head: [['#', 'Code', 'Name', 'Mobile', 'Category', 'Site', 'Rate', 'Advance', 'Dues']],
  body: tableData,
  theme: 'grid',
  headStyles: { fillColor: [26, 35, 126], textColor: 255, fontSize: 9 },
  bodyStyles: { fontSize: 8 },
  alternateRowStyles: { fillColor: [245, 245, 245] },
});

  doc.save(`Labour_List_${new Date().toISOString().split('T')[0]}.pdf`);
};

  const getCategoryColor = (code) => {
    const colors = { MAN: '#1976d2', LAD: '#e91e63', MAS: '#ff9800', CAR: '#795548' };
    return colors[code] || '#666';
  };

  return (
    <Box sx={{ p: { xs: 1, sm: 2, md: 3 }, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      <Paper sx={{ p: { xs: 1, sm: 2, md: 3 }, borderRadius: 3 }}>
        {success && <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>{success}</Alert>}
  {error && <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>{error}</Alert>}
  
  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 1 }}>
    <Typography variant="h5" fontWeight="bold">👥 Labour List</Typography>
  
<Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', width: { xs: '100%', sm: 'auto' } }}>
  <Button
    variant="contained"
    color="success"
    startIcon={<FileDownload />}
    onClick={handleExportExcel}
    disabled={labour.length === 0}
    sx={{ flex: { xs: '1 1 calc(50% - 4px)', sm: 'none' }, fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
  >
    Excel
  </Button>
  <Button
    variant="contained"
    color="error"
    startIcon={<PictureAsPdf />}
    onClick={handleExportPDF}
    disabled={labour.length === 0}
    sx={{ flex: { xs: '1 1 calc(50% - 4px)', sm: 'none' }, fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
  >
    PDF
  </Button>
  <Button 
    variant="contained" 
    startIcon={<Add />} 
    onClick={() => navigate('/labour/register')}
    sx={{ flex: { xs: '1 1 100%', sm: 'none' }, fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
  >
    Add Labour
  </Button>
</Box>

</Box>
        {tab === 0 && (
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth size="small" label="Search" value={filters.search}
                onChange={(e) => setFilters({ ...filters, search: e.target.value })}
                onKeyPress={(e) => { if (e.key === 'Enter') handleSearch(); }}
                placeholder="Name, Mobile, Code"
                InputProps={{ endAdornment: <Search /> }}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth select size="small" label="Category" value={filters.category_id}
                onChange={(e) => setFilters({ ...filters, category_id: e.target.value })}
              >
                <MenuItem value="">All Categories</MenuItem>
                {categories.map(cat => (
                  <MenuItem key={cat.id} value={cat.id}>{cat.category_name}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth select size="small" label="Site" value={filters.site_id}
                onChange={(e) => setFilters({ ...filters, site_id: e.target.value })}
              >
                <MenuItem value="">All Sites</MenuItem>
                {sites.map(site => (
                  <MenuItem key={site.id} value={site.id}>{site.site_name}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={2}>
              <Button fullWidth variant="outlined" onClick={handleSearch} sx={{ py: 1 }} disabled={loading}>
                {loading ? <CircularProgress size={20} /> : 'Filter'}
              </Button>
            </Grid>
          </Grid>
        )}

        <Typography variant="body2" sx={{ mb: 1 }}>
          Total Active Labour: <strong>{totalActive}</strong>
        </Typography>

        <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ mb: 2 }}>
          <Tab label="Active Labour" />
          <Tab label="Left Labour" />
        </Tabs>

        {tab === 0 && (
          <TableContainer sx={{ overflowX: 'auto' }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                  <TableCell><strong>#</strong></TableCell>
                  <TableCell><strong>Code</strong></TableCell>
                  <TableCell><strong>Name</strong></TableCell>
                  <TableCell><strong>Mobile</strong></TableCell>
                  <TableCell><strong>Category</strong></TableCell>
                  <TableCell><strong>Site</strong></TableCell>
                  <TableCell><strong>Rate</strong></TableCell>
                  <TableCell><strong>Advance</strong></TableCell>
<TableCell><strong>Dues</strong></TableCell>
                  <TableCell><strong>Action</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {labour.map((lab, index) => (
                  <TableRow key={lab.id} hover>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{lab.labour_code}</TableCell>
                    <TableCell>{lab.name}</TableCell>
                    <TableCell>{lab.mobile || '-'}</TableCell>
                    <TableCell>
                      <Chip
                        label={lab.category_name}
                        size="small"
                        sx={{ bgcolor: getCategoryColor(lab.category_code), color: 'white' }}
                      />
                    </TableCell>
                    <TableCell>{lab.site_name}</TableCell>
                    <TableCell>₹{lab.our_rate_8hr || '-'}</TableCell>
                    <TableCell>₹{Number(lab.total_advance_taken || 0).toLocaleString()}</TableCell>
<TableCell>
  ₹{Number(lab.balance_due || 0).toLocaleString()}
  {Number(lab.balance_due) > 0 ? ' (Dues)' : ' (Settled)'}
</TableCell>
                    <TableCell>
  <IconButton size="small" color="primary" onClick={() => handleViewDetails(lab)}>
    <Visibility />
  </IconButton>
  <IconButton size="small" color="warning" onClick={() => handleEditOpen(lab)} title="Edit">
    <Edit />
  </IconButton>
  <IconButton size="small" color="error" onClick={() => handleToggleStatus(lab.id, false)} title="Mark as Left">
    <Close />
  </IconButton>
</TableCell>
                  </TableRow>
                ))}
                {labour.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={10} align="center">No labour found</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {tab === 1 && (
          <TableContainer sx={{ overflowX: 'auto' }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                  <TableCell>#</TableCell>
                  <TableCell>Code</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Mobile</TableCell>
                  <TableCell>Advance Taken</TableCell>
                  <TableCell>Recovered</TableCell>
                  <TableCell>Balance Due</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {inactiveLabour.map((lab, index) => (
                  <TableRow key={lab.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{lab.labour_code}</TableCell>
                    <TableCell>{lab.name}</TableCell>
                    <TableCell>{lab.mobile || '-'}</TableCell>
                    <TableCell>₹{Number(lab.total_advance_taken || 0).toLocaleString()}</TableCell>
                    <TableCell>₹{Number(lab.total_advance_recovered || 0).toLocaleString()}</TableCell>
                    <TableCell>
                      ₹{Number(lab.balance_due || 0).toLocaleString()}
                      {Number(lab.balance_due) > 0 ? ' (Dues)' : ' (Settled)'}
                    </TableCell>
                  </TableRow>
                ))}
                {inactiveLabour.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={7} align="center">No left labour</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>

      <Dialog open={openDetails} onClose={() => setOpenDetails(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          Labour Details
          <IconButton onClick={() => setOpenDetails(false)} sx={{ float: 'right' }}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {selectedLabour && (
            <Grid container spacing={2}>
              <Grid item xs={6}><Typography variant="body2" color="text.secondary">Name</Typography><Typography fontWeight="bold">{selectedLabour.name}</Typography></Grid>
              <Grid item xs={6}><Typography variant="body2" color="text.secondary">Code</Typography><Typography fontWeight="bold">{selectedLabour.labour_code}</Typography></Grid>
              <Grid item xs={6}><Typography variant="body2" color="text.secondary">Mobile</Typography><Typography>{selectedLabour.mobile || '-'}</Typography></Grid>
              <Grid item xs={6}><Typography variant="body2" color="text.secondary">Category</Typography><Typography>{selectedLabour.category_name}</Typography></Grid>
              <Grid item xs={6}><Typography variant="body2" color="text.secondary">Site</Typography><Typography>{selectedLabour.site_name}</Typography></Grid>
              <Grid item xs={6}><Typography variant="body2" color="text.secondary">Company Rate</Typography><Typography>₹{selectedLabour.company_rate_8hr}</Typography></Grid>
              <Grid item xs={6}><Typography variant="body2" color="text.secondary">Our Rate</Typography><Typography>₹{selectedLabour.our_rate_8hr}</Typography></Grid>
              <Grid item xs={12}><Typography variant="body2" color="text.secondary">Address</Typography><Typography>{selectedLabour.address || '-'}</Typography></Grid>
            </Grid>
          )}
        </DialogContent>
      </Dialog>

{/* Edit Dialog */}
<Dialog open={openEdit} onClose={() => setOpenEdit(false)} maxWidth="sm" fullWidth>
  <DialogTitle>
    Edit Labour Details
    <IconButton onClick={() => setOpenEdit(false)} sx={{ float: 'right' }}>
      <Close />
    </IconButton>
  </DialogTitle>
  <DialogContent dividers>
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth label="Name" value={editForm.name}
          onChange={(e) => setEditForm({ ...editForm, name: e.target.value })}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth label="Mobile" value={editForm.mobile}
          onChange={(e) => setEditForm({ ...editForm, mobile: e.target.value })}
          inputProps={{ maxLength: 10 }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth label="Aadhar" value={editForm.aadhar_no}
          onChange={(e) => setEditForm({ ...editForm, aadhar_no: e.target.value })}
          inputProps={{ maxLength: 12 }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth label="Emergency Contact" value={editForm.emergency_contact}
          onChange={(e) => setEditForm({ ...editForm, emergency_contact: e.target.value })}
          inputProps={{ maxLength: 10 }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth select label="Category" value={editForm.category_id}
          onChange={(e) => setEditForm({ ...editForm, category_id: e.target.value })}
        >
          {categories.map(c => (
            <MenuItem key={c.id} value={c.id}>{c.category_name}</MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth select label="Site" value={editForm.site_id}
          onChange={(e) => setEditForm({ ...editForm, site_id: e.target.value })}
        >
          {sites.map(s => (
            <MenuItem key={s.id} value={s.id}>{s.site_name}</MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth label="Address" multiline rows={2} value={editForm.address}
          onChange={(e) => setEditForm({ ...editForm, address: e.target.value })}
        />
      </Grid>
    </Grid>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenEdit(false)}>Cancel</Button>
    <Button variant="contained" onClick={handleEditSave}>Save Changes</Button>
  </DialogActions>
</Dialog>
</Box>
);
};

export default LabourList;